export const formatNumber = (value: number | null | undefined): string => {
  if (value === null || value === undefined) return '';
  
  // Use Intl.NumberFormat for standardized number formatting
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  }).format(value);
};

// For currency formatting
export const formatCurrency = (value: number | null | undefined, currency: string | null | undefined ): string => {
  if (value === null || value === undefined) return '';
  if (currency === null || currency === undefined) return 'USD';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  }).format(value);
};

// For percentage formatting
export const formatPercentage = (value: number | null | undefined): string => {
  if (value === null || value === undefined) return '';
  
  return new Intl.NumberFormat('en-US', {
    style: 'percent',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(value / 100); // Divide by 100 since input is expected to be in whole numbers
}; 